export default "__VITE_ASSET__CVhmx$U7__"